import { render, staticRenderFns } from "./IntegrationCreateShippingSuccessMessage.vue?vue&type=template&id=21b015c2"
import script from "./IntegrationCreateShippingSuccessMessage.vue?vue&type=script&lang=js"
export * from "./IntegrationCreateShippingSuccessMessage.vue?vue&type=script&lang=js"
import style0 from "./IntegrationCreateShippingSuccessMessage.vue?vue&type=style&index=0&id=21b015c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports